import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-cut"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 9.5C3.34315 9.5 2 8.15685 2 6.5C2 4.84315 3.34315 3.5 5 3.5C6.65685 3.5 8 4.84315 8 6.5C8 8.15685 6.65685 9.5 5 9.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 17.5C8 19.1569 6.65685 20.5 5 20.5C3.34315 20.5 2 19.1569 2 17.5C2 15.8431 3.34315 14.5 5 14.5C6.65685 14.5 8 15.8431 8 17.5Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 5.80769L7.5 15.5001M7.5 8.5L15.5 14.5577M5 9.5C3.34315 9.5 2 8.15685 2 6.5C2 4.84315 3.34315 3.5 5 3.5C6.65685 3.5 8 4.84315 8 6.5C8 8.15685 6.65685 9.5 5 9.5ZM8 17.5C8 19.1569 6.65685 20.5 5 20.5C3.34315 20.5 2 19.1569 2 17.5C2 15.8431 3.34315 14.5 5 14.5C6.65685 14.5 8 15.8431 8 17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.25 17L19.7697 18.2303L21 18.75L19.7697 19.2697L19.25 20.5L18.7303 19.2697L17.5 18.75L18.7303 18.2303L19.25 17Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiCut = Vue.extend<IconProps>({
  name: 'AiCutIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-cut',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiCut;
